import axios from 'axios';

const model = 'Pregunta'
const API_URL = process.env.VUE_APP_API_URL;

export default {
  get(page, size) {
    return axios.get(`${API_URL}/${model}/v1/list/${page}/${size}`);
  },

 saveQuestions(payload) {
    return axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/v2/save/question`, payload)
      .then(response => {
        console.log('Pregunta guardada con éxito:', response.data);
        return response.data; // Devuelve los datos de la respuesta si es necesario
      })
      .catch(error => {
        console.error('Error al guardar la pregunta en el backend:', error);
        throw error; // Propaga el error para manejarlo en el componente
      });
  },

  saveSimceQuestion(payload) {
    return axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/v2/save/save-simce`, payload)
      .then(response => response.data)
      .catch(error => {
        console.error('Error al guardar pregunta SIMCE:', error);
        throw error;
      });
  },

async uploadQuestionImage(formData) {
  try {
    const response = await axios.post(
      `${process.env.VUE_APP_API_URL_LOCAL}/v2/preguntas/upload-imagen`,
      formData,
      {
        headers: {
          // Authorization: `Bearer ${store.getters['auth/access-token']}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  } catch (error) {
    throw new Error(`Error uploading image: ${error.message}`);
  }
},

async getQuestionsByUnitAndChapter({ idEjeTematico, idCapitulo, idVideo }) {
  try {
    const params = { idEjeTematico, idCapitulo };
    if (idVideo != null && idVideo > 0) params.idVideo = idVideo;
    const response = await axios.get(
      `${process.env.VUE_APP_API_URL_LOCAL}/v2/preguntas/por-unidad-y-capitulo`,
      { params }
    );
    return response;
  } catch (error) {
    throw new Error(`Error fetching questions: ${error.message}`);
  }
},

async actualizarDescripcionImagenPregunta(idPregunta, descripcionImagenPregunta) {
  try {
    return await axios.put(
      `${process.env.VUE_APP_API_URL_LOCAL}/v2/preguntas/${idPregunta}/descripcion-imagen`,
      { DescripcionImagenPregunta: descripcionImagenPregunta }
    );
  } catch (error) {
    throw new Error(`Error actualizando descripción de imagen: ${error.message}`);
  }
},

async actualizarGlosaPregunta(idPregunta, glosa) {
  try {
    return await axios.put(
      `${process.env.VUE_APP_API_URL_LOCAL}/v2/preguntas/${idPregunta}/glosa`,
      { Glosa: glosa }
    );
  } catch (error) {
    throw new Error(`Error actualizando glosa de la pregunta: ${error.message}`);
  }
},

async desactivarPregunta(idPregunta) {
  try {
    return await axios.put(
      `${process.env.VUE_APP_API_URL_LOCAL}/v2/preguntas/${idPregunta}/desactivar`
    );
  } catch (error) {
    throw new Error(`Error desactivando pregunta: ${error.message}`);
  }
},


 UpdatePortadaVideo(id_video) {
    return axios.get(`${process.env.VUE_APP_API_URL_LOCAL}/v2/video/update-portada/${id_video}`);
  },



  actualizar(id, usuario) {
    return axios.put(`${API_URL}/${model}/v1/${id}`, usuario);
  },

  eliminar(id) {
    return axios.delete(`${API_URL}/${model}/v1/${id}`);
  },

  buscarPorMail(email) {
    return axios.get(`${API_URL}/${model}/v1/buscar/${email}`)
  },


}